import { render, staticRenderFns } from "./bailApply.vue?vue&type=template&id=c2f1bbd2&scoped=true"
import script from "./bailApply.vue?vue&type=script&lang=js"
export * from "./bailApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f1bbd2",
  null
  
)

export default component.exports